// extracted by mini-css-extract-plugin
module.exports = {"container":"cd01fbf7b5--container--rzQNk","image":"cd01fbf7b5--image--N7ZLf","title":"cd01fbf7b5--title--xr3tK","link":"cd01fbf7b5--link--DPBFh"};